import React, { PropTypes, Component } from 'react'
import PreviousIcon from './icons/previous.svg'

class PreviousButton extends Component {
  render () {
    return (
      <button className={this.props.className} type='button' onClick={this.props.handlePrevious}>
        <img alt='Previous' src={PreviousIcon} />
      </button>
    )
  }
}

PreviousButton.propTypes = {
  handlePrevious: PropTypes.func,
  className: PropTypes.string
}

export default PreviousButton



/** WEBPACK FOOTER **
 ** ./src/components/PreviousButton.js
 **/